export const leaderboardMessages = {
  'zh-CN': {
    mapTip: {
      details: '详情', openPage: '在新标签页查看 {name} 的地图资料',
      open: '查看 {name} 的地图资料', kind: '地图', loading: '正在加载地图资料', empty: '暂无地图资料',
      error: '地图资料加载失败，请重试', monsterCount: '怪物数量', npcCount: 'NPC 数量',
      monsters: '出没怪物', npcs: '出没 NPC', description: '地图说明', noNpcs: '暂无 NPC', noMonsters: '暂无怪物',
      more: '还有 {count} 条…', image: '{name} 的小地图', noImage: '暂无小地图预览',
    },
    title: '练级地图排行',
    levelRange: '{start}–{end} 级', levelSample: '该行统计来自 {start}–{end} 级角色的记录',
    allLevels: '全部', minutes: '{count} 分钟',
    sampleAccumulation: '同一玩家在同一地图、等级段和数据来源下的多段记录可累计形成样本。查询全部等级时，各等级段独立计算和展示。',
    level: '等级', position: '排名', status: '状态', collectingTab: '积累中', formalTab: '正式榜', sourceFilter: '来源',
    hourlyExp: '经验/小时', hourlyReference: '参考经验/小时', records: '共 {count} 条',
    sourceSamples: '数据来源', allSourcesShort: '全部', collapse: '收起详情', closeDetails: '收起 {name} 的详情',
    exp: '经验效率', perHour: '经验 / 小时', typical: '排行依据', samples: '参与数据',
    filters: '筛选', filterTitle: '筛选地图', reset: '重置筛选', done: '查看结果',
    search: '搜索地图', searchPlaceholder: '搜索地图名称或 ID', searchClear: '清空搜索',
    filtersOpen: '打开筛选', filtersCount: '{count} 项已选', removeFilter: '移除 {label}',
    rules: '统计规则', details: '地图详情', openDetails: '查看 {name} 的详情',
    scope: '{level} · {job} · {source}', count: '{count} 张地图',
    page: '第 {current} / {total} 页', previous: '上一页', next: '下一页', goToPage: '转到第 {page} 页',
    scale: '本页效率对比', sorted: '按中间水平排序', collecting: '数据积累中',
    moreUsers: '还差 {count} 位玩家', moreMinutes: '还差 {count} 分钟', met: '已满足',
    usersProgress: '参与人数', timeProgress: '有效时长', sampleRule: '正式榜条件',
    uploadRule: '枫记上传条件',
    uploadSourceRule: '必须使用窗口共享。每次共享仅检查一次标题，明确不是“冒险岛怀旧服”时，整条记录不上传；全屏无标题栏或标题未确认时默认允许。记录一旦被排除，切换窗口或全屏不会恢复该条记录的资格。本地统计和历史保存不受影响。',
    sourceNotice: {
      'capture-not-window': '本次记录不参与排行榜：必须使用窗口共享。本地统计照常；重新共享窗口并开始新记录后可重新判断。',
      'capture-title-mismatch': '本次记录不参与排行榜：窗口标题不符合条件。本地统计照常；重新共享目标游戏并开始新记录后可重新判断。',
    },
    uploadEligibility: '同一地图、同一等级段（每 5 级一档），单段有效经验记录满 {minutes} 分钟且有经验收益，即可上传。不同片段不拼接凑时长。',
    uploadTiming: '结束记录后自动上传达标片段。中途暂停或掉线，已达标的片段仍会保留。',
    qualificationHelp: '数据不足的地图会显示在“积累中”。',
    distribution: '不同玩家的经验效率', source: '数据来源', updated: '最近更新',
    median: '中间水平', low: '较低水平', high: '较高水平', upper: '高效水平',
    medianHelp: '按玩家每小时经验的“中间水平”排名，只计入有效记录。',
    rangeHelp: '约一半玩家处于“较低水平”到“较高水平”之间。“高效水平”接近前 10%，不是最高纪录。',
    empty: '这里还没有地图', emptyHint: '试试搜索地图，或调整等级、职业、来源。',
    error: '暂时无法获取排行', refreshFailed: '更新失败，保留上次结果。',
    reference: '参考效率', pending: '等待榜单更新',
    back: '返回榜单', closeDossier: '关闭地图档案',
    dossier: '地图档案', identity: '地图', efficiency: '练级效率', trust: '样本可信度',
    monsters: '出没怪物', drops: '核心掉落', equipment: '装备', scroll: '卷轴',
    dropRateLabel: '爆率 {rate}，{tier}',
    dropRateTier: {"high": "相对较高", "medium": "相对中等", "low": "相对较低", "neutral": ""},
    dropRateValue: "爆率 {rate}",
    dropSources: "掉落来源",
    allDropMonsters: "全部怪物",
    dropMonsterFilter: "筛选掉落怪物",
    unknownDropRate: "未知",
    noDropSources: "暂无来源资料",
    relativeDropRates: "颜色表示当前筛选内的相对爆率。",
    maxMonsterDropRate: "取本图来源怪物的最高已知爆率，不叠加角色掉率加成。",
    noMonsters: '这张图还没有怪物资料', noDrops: '这张图还没有核实掉落',
    noMapDetail: '这张图还没有地图档案', notes: '地图说明',
    loadingDetail: '正在加载地图资料', detailError: '地图资料加载失败',
    openBooklet: '在小册子查看', openBookletNamed: '在小册子查看 {name}',
    spawn: '{count} 只', monsterLevel: 'Lv.{level}',
    trustFormal: '{users} 位玩家 · {duration}',
    trustUsersUnit: '位玩家',
    hoursUnit: '小时',
    collectingNeed: '还差 {users} 人 · {time}',
    selectMap: '查看 {name}',
    moreFilters: '更多筛选',
    partnership: '与小册子联动',
    entityLoading: '正在加载资料', entityEmpty: '暂无资料', entityError: '资料加载失败',
    entityKind: { mob: '怪物', item: '道具' },
  },
  en: {
    uploadSourceRule: 'Window sharing is required. The title is checked once per share. A clearly different title from 冒险岛怀旧服 excludes the entire recording. Fullscreen captures without a title bar and unconfirmed titles are allowed by default. Changing windows or entering fullscreen does not restore an excluded recording. Local statistics and history are unaffected.',
    sourceNotice: {
      'capture-not-window': 'This recording is excluded from rankings: window sharing is required. Local tracking continues. Share a window and start a new recording to qualify again.',
      'capture-title-mismatch': 'This recording is excluded from rankings: the window title does not match. Local tracking continues. Share the target game and start a new recording to qualify again.',
    },
    mapTip: {
      details: 'Details', openPage: 'Open map information for {name} in a new tab',
      open: 'View map information for {name}', kind: 'Map', loading: 'Loading map information', empty: 'No map information available',
      error: 'Could not load map information. Please retry.', monsterCount: 'Monsters', npcCount: 'NPCs',
      monsters: 'Monsters in this map', npcs: 'NPCs in this map', description: 'Map notes', noNpcs: 'No NPCs', noMonsters: 'No monsters',
      more: '{count} more…', image: 'Minimap of {name}', noImage: 'Minimap unavailable',
    },
    title: 'Leveling map rankings',
    levelRange: 'Lv. {start}–{end}', levelSample: 'This row uses records from characters at levels {start}–{end}',
    allLevels: 'All', minutes: '{count} minutes',
    sampleAccumulation: 'A player’s records on the same map, in the same level range and from the same source can accumulate into one sample. All-level rankings calculate and display each level range separately.',
    level: 'Level', position: 'Rank', status: 'Status', collectingTab: 'Collecting', formalTab: 'Official', sourceFilter: 'Source',
    hourlyExp: 'EXP/hour', hourlyReference: 'Reference EXP/hour', records: '{count} records',
    sourceSamples: 'Data sources', allSourcesShort: 'All', collapse: 'Collapse details', closeDetails: 'Close details for {name}',
    exp: 'EXP efficiency', perHour: 'EXP / hour', typical: 'How rankings are calculated', samples: 'Contributing data',
    filters: 'Filters', filterTitle: 'Filter maps', reset: 'Reset filters', done: 'View results',
    search: 'Search maps', searchPlaceholder: 'Search by map name or ID', searchClear: 'Clear search',
    filtersOpen: 'Open filters', filtersCount: '{count} selected', removeFilter: 'Remove {label}',
    rules: 'Ranking rules', details: 'Map details', openDetails: 'View details for {name}',
    scope: '{level} · {job} · {source}', count: '{count} maps',
    page: 'Page {current} / {total}', previous: 'Previous page', next: 'Next page', goToPage: 'Go to page {page}',
    scale: 'This page comparison', sorted: 'Sorted by the middle pace', collecting: 'Collecting data',
    moreUsers: '1 more player | {count} more players', moreMinutes: '1 more minute | {count} more minutes', met: 'Met',
    usersProgress: 'Players', timeProgress: 'Valid time', sampleRule: 'Official ranking requirements',
    uploadRule: 'Maple Log upload requirements',
    uploadEligibility: 'Each segment needs {minutes} minutes of valid EXP data and a positive EXP gain on the same map and within the same five-level range. Separate segments are not combined.',
    uploadTiming: 'Eligible segments upload automatically when you end the session. Pauses or disconnections do not discard segments that already qualify.',
    qualificationHelp: 'Maps needing more data appear under Collecting.',
    distribution: 'EXP rates across players', source: 'Data sources', updated: 'Last updated',
    median: 'Middle pace', low: 'Lower pace', high: 'Higher pace', upper: 'Fast pace',
    medianHelp: 'Maps are ranked by the middle EXP/hour result across players. Only valid records count.',
    rangeHelp: 'About half of players fall between the Lower and Higher pace. Fast pace is near the top 10%, not the record high.',
    empty: 'No maps here yet', emptyHint: 'Try searching for a map, or pick a different level range, job, or source.',
    error: 'Rankings could not be loaded', refreshFailed: 'Refresh failed. Previous results are still shown.',
    reference: 'Reference efficiency', pending: 'Awaiting ranking update',
    back: 'Back to list', closeDossier: 'Close map dossier',
    dossier: 'Map dossier', identity: 'Map', efficiency: 'Training pace', trust: 'Sample confidence',
    monsters: 'Monsters', drops: 'Notable drops', equipment: 'Equipment', scroll: 'Scrolls',
    dropRateLabel: 'Drop rate {rate}, {tier}',
    dropRateTier: {"high": "relatively high", "medium": "relative middle", "low": "relatively low", "neutral": ""},
    dropRateValue: "Drop rate {rate}",
    dropSources: "Dropped by",
    allDropMonsters: "All monsters",
    dropMonsterFilter: "Filter drop monsters",
    unknownDropRate: "Unknown",
    noDropSources: "No source data available",
    relativeDropRates: "Colors compare drop rates within the current filter.",
    maxMonsterDropRate: "Highest known rate among source monsters in this map, before character bonuses.",
    noMonsters: 'No monster data for this map yet', noDrops: 'No verified drops for this map yet',
    noMapDetail: 'No dossier for this map yet', notes: 'Map notes',
    loadingDetail: 'Loading map details', detailError: 'Could not load map details',
    openBooklet: 'Open in Xiaoces', openBookletNamed: 'Open {name} in Xiaoces',
    spawn: '{count}', monsterLevel: 'Lv.{level}',
    trustFormal: '{users} players · {duration}',
    trustUsersUnit: 'players',
    hoursUnit: 'hr',
    collectingNeed: '{users} more · {time}',
    selectMap: 'View {name}',
    moreFilters: 'More filters',
    partnership: 'With Xiaoces',
    entityLoading: 'Loading details', entityEmpty: 'No details available', entityError: 'Could not load details',
    entityKind: { mob: 'Monster', item: 'Item' },
  },
}
